<script setup lang="ts">
  import { computed, useTemplateRef } from 'vue'
  import { fmt, randomId } from '@/functions'

  const props = defineProps<{
    id?: string,
    label?: string,
    placeholder?: string,
    required?: boolean,
    error?: string | string[],
    disabled?: boolean,
    modelValue: string,
    min?: Date,
  }>()

  const model = defineModel<string>()

  const formattedDate = computed(() => {
    if (model.value) {
      return fmt.date(model.value, 'd MMM yyyy')
    }

    return ''
  })

  const defaultId = randomId()
  const inputId = computed(() => props.id ?? 'text-' + defaultId)
  const inputRef = useTemplateRef<HTMLInputElement>('input')

  const openDatePicker = () => {
    inputRef.value?.focus()
    setTimeout(() => {
      inputRef.value?.showPicker()
    }, 100)
  }
</script>

<template>
  <div class="relative">
    <input
      ref="input"
      v-model="model"
      type="date"
      class="absolute inset-0 opacity-0 -z-1"
      :disabled="disabled"
      :min="min ? fmt.date(min, 'yyyy-MM-dd') : undefined"
      tabindex="9999">
    <app-input
      :id="inputId"
      :model-value="formattedDate"
      :label="label"
      :error="error"
      :required="required"
      readonly
      class="min-w-32"
      :placeholder="placeholder"
      @focus="openDatePicker()"
      @click="openDatePicker()">
      <template #inline>
        <div
          class="datepicker-icon"
          :class="{
            'text-gray-300': disabled,
          }">
          <fa-icon icon="i-far-calendar" />
        </div>
      </template>
    </app-input>
  </div>
</template>

<style lang="postcss" scoped>
  .datepicker-icon {
    @apply absolute bottom-0 flex items-center text-sm leading-0 pr-2 right-0 pointer-events-none;
    @apply text-gray;
    @apply h-9; /* height of form-input */
  }
</style>
